import { MOTION } from '@/utils';
import { LOGOS } from '@/utils/data/logo';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import Image from 'next/image';
import { useRef } from 'react';

export default function Adaptative() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const logosRef = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    if (!sectionRef.current || !logosRef.current) return;
    const logos = logosRef.current.children;

    const splitTitle = new SplitText(titleRef.current, {
      type: 'lines',
      mask: 'lines',
    });
    const splitText = new SplitText(textRef.current, {
      type: 'lines',
      mask: 'lines',
    });

    const tl = gsap.timeline({
      defaults: {
        duration: MOTION.durationMd,
        ease: MOTION.ease,
        stagger: MOTION.staggerLines,
      },
      scrollTrigger: {
        start: 'top 60%',
        toggleActions: 'play none none reverse',
        trigger: sectionRef.current,
      },
    });

    tl.from(splitTitle.lines, {
      yPercent: MOTION.yPercent,
    })
      .from(
        splitText.lines,
        {
          yPercent: MOTION.yPercent,
        },
        '<+0.2',
      )
      .from(
        logos,
        {
          autoAlpha: 0,
          stagger: 0.02,
          y: MOTION.y,
        },
        '<+0.2',
      );
  });

  return (
    <section ref={sectionRef} className="max-width-white-section">
      <div className="max-width-white-section-content container-adaptative flex flex-col items-center gap-8 text-center">
        <div className="flex w-full flex-col items-center gap-2">
          <h2 ref={titleRef} className="text-orange">
            zLawyer s&apos;adapte à votre organisation
          </h2>
          <p ref={textRef} aria-hidden="true" className="w-full md:w-3/4">
            Que votre cabinet soit équipé d&apos;un <span className="font-roboto-bold">NAS</span>,
            d&apos;un serveur ou encore d&apos;un <span className="font-roboto-bold">cloud</span>,
            zLawyer <span className="font-roboto-bold">s&apos;adapte</span> parfaitement à{' '}
            <span className="font-roboto-bold">votre organisation</span>. zLawyer est{' '}
            <span className="font-roboto-bold whitespace-nowrap">100% compatible</span> avec les
            technologies actuelles de stockage.
          </p>

          <p className="sr-only">
            Que votre cabinet soit équipé d&apos;un NAS, d&apos;un serveur ou encore d&apos;un
            cloud, zLawyer s&apos;adapte parfaitement à votre organisation. zLawyer est 100%
            compatible avec les technologies actuelles de stockage.
          </p>
        </div>

        <div ref={logosRef} className="grid grid-cols-3 justify-items-center gap-2 md:grid-cols-6">
          {LOGOS.map((logo, _) => (
            <Image
              key={logo.src}
              alt={logo.alt}
              className="h-20 w-auto object-contain"
              decoding="async"
              height={logo.height}
              loading="lazy"
              src={logo.src}
              width={logo.width}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
